"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalculationRow = void 0;
const react_1 = __importDefault(require("react"));
const global_1 = require("../../global");
const CalculationRow_styles_1 = require("./CalculationRow.styles");
const CalculationRow = ({ label, type, value, description, enableToolTip, toolTipKey, odd, }) => {
    return (react_1.default.createElement(CalculationRow_styles_1.Row, { "$odd": odd },
        react_1.default.createElement(CalculationRow_styles_1.Label, null, label),
        react_1.default.createElement(global_1.TypedValue, { type: type, value: value, description: description, enableToolTip: enableToolTip, toolTipKey: toolTipKey })));
};
exports.CalculationRow = CalculationRow;
//# sourceMappingURL=CalculationRow.js.map